<template>
  <div class="lever-main">
    <!-- 蒙版 -->
    <div class="mask" key="1" @touchmove.prevent></div>
    <div class="child-content" key="2">
      <div class="child-main">
        <div class="modal-header">
          <span>{{ $t('upgradeBatch') }}</span>
          <img @click="handleClose" class="close" src="@/icon/ic_cancle.png" alt="" />
        </div>
        <el-button type="primary" class="add-btn" @click="UpAppLever()">{{ $t('newlyAded') }}</el-button>
        <Table
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :showSelcet="false"
          @operate="childOperationEvent"
          :operationWidth="160"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
      <!-- 新增/ 编辑 -->
      <el-dialog
        :title="addOrEditChild ? $t('newBatchIformation') : $t('editBatchInformation')"
        :visible.sync="dialogChildApp"
        :append-to-body="true"
        width="880px"
        class="common-blue-contain add-app"
        :close-on-click-modal="false"
      >
        <el-form :model="fromData">
          <div class="settingDialog">
            <div class="left-content">
              <el-form-item :label="$t('imageName')" :label-width="formLabelWidth">
                <el-input v-model="fromData.imgName" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item
                :label="appActiveName === 'androidImg' ? $t('ImageID') : $t('appID')"
                :label-width="formLabelWidth"
              >
                <el-input v-model="fromData.seriesId" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$t('versionNo')" :label-width="formLabelWidth">
                <el-input v-model="fromData.versionName" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item
                :label="$t('upgradeMethod')"
                :label-width="formLabelWidth"
                :required="true"
                v-if="appActiveName === 'androidImg'"
              >
                <el-radio-group v-model="fromData.upgradeMode">
                  <el-radio :label="1" value="1">{{ $t('manualConfirmation') }}</el-radio>
                  <el-radio :label="2" value="2">{{ $t('automaticupgrade') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('effectiveStartTime')" :label-width="formLabelWidth" :required="true">
                <el-date-picker
                  v-model="fromData.openTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  popper-class="date-picker-blue-hw"
                  :clearable="true"
                  :placeholder="$t('peaseSelect') + $t('effectiveStartTime')"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('versionDescription')" :label-width="formLabelWidth">
                <el-input v-model="fromData.description" :disabled="true" type="textarea" :rows="4"></el-input>
              </el-form-item>
            </div>

            <div class="right-content">
              <el-form-item :label="$t('searchUpgradeScope')" :label-width="formLabelWidth">
                <el-input v-model="searchOu" :placeholder="$t('searchUpgradeScope')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('upgradeScope')"  class="check-box" :label-width="formLabelWidth" :required="true">
                <!-- <div class="check-box"> -->
                  <el-tree
                    class="check-tree"
                    ref="childCheckTree"
                    :data="rootTree"
                    :default-checked-keys="checkList"
                    show-checkbox
                    node-key="id"
                    :default-expand-all="true"
                    :props="defaultProps"
                    :check-on-click-node="true"
                    :filter-node-method="filterNode"
                    :check-strictly="isCheck"
                  >
                    <div class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>
                      <div v-if="data.disabled" class="disabled" @click.stop></div>
                    </div>
                  </el-tree>
                <!-- </div> -->
              </el-form-item>
            </div>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="berforSubChildCheck(addOrEditChild)">{{ $t('determine') }}</el-button>
          <el-button @click="dialogChildApp = false">{{ $t('cancel') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import { errorMessage } from '@/util/common'
import { errorCollection } from '@/api/dmp/dmpCollection'
import {
  getUpgradebatch,
  addUpgradebatch,
  editUpgradebatch,
  deleteUpgradebatch,
  orgunitRootTree,
  queryOuByCheck,
} from '@/api/upgrade'
export default {
  props: {
    childValue: {
      type: Object,
      default: () => [],
    },
    appActiveName: {
      type: String,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // table 组件表头参数数组
      columns: [],
      // table 操作栏参数数组
      dateOperation: [],
      // 表格数据
      tableData: [],
      // 组织机构数据
      rootTree: [],
      defaultProps: {
        label: 'name',
        children: 'children',
        disabled: this.disabledFn,
      },
      formLabelWidth: '165px',
      // 新增/编辑批次信息弹窗参数组
      fromData: {
        imgName: '',
        seriesId: '',
        versionName: '',
        upgradeMode: 1,
        description: '',
        openTime: '',
        ous: [],
      },
      // 机构租户已选显示
      checkList: [],
      // 新增/编辑批次信息弹窗 显示
      dialogChildApp: false,
      // 新增/编辑批次信息弹窗 标题显示
      addOrEditChild: false,
      currentItem: {},
      ouByCheck: [],
      // 搜索机构
      searchOu: '',
      currentChecks: [],
      isCheck: false,
      formInline: {
        sortColName: '',
        useAsc: null,
      },
    }
  },
  watch: {
    searchOu(val) {
      // 监听搜索机构
      this.$refs.childCheckTree.filter(val)
    },
  },
  components: { Table },
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.currentPage = 1
      this._getUpgradebatch()
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    disabledFn(data) {
      // 禁用机构租户
      return this.ouByCheck && this.ouByCheck.indexOf(data.id + '') > -1
    },
    // 确认新增批次
    berforSubChildCheck() {
      // 获取选择的机构租户
      let ouIds = []
      let childNodesArr = this.$refs.childCheckTree.getCheckedNodes()
      console.log(childNodesArr, 'childNodesArr')
      for (let i = 0; i < childNodesArr.length; i++) {
        if (!this.ouByCheck || this.ouByCheck.indexOf(childNodesArr[i].id + '') <= -1) {
          ouIds.push({
            id: childNodesArr[i].id,
            tenantId: childNodesArr[i].tenantId,
            dataType: childNodesArr[i].dataType,
          })
        }
      }
      let parent = this.$refs.childCheckTree.getHalfCheckedNodes()
      console.log(parent, 'parent')
      for (let i = 0; i < parent.length; i++) {
        ouIds.push({
          id: parent[i].id,
          tenantId: parent[i].tenantId,
          dataType: parent[i].dataType,
        })
      }
      let param = {
        imgId: this.childValue.imgId,
        ous: ouIds,
        upgradeMode: this.fromData.upgradeMode,
        openTime: this.fromData.openTime,
      }
      if (this.fromData.upgradeMode === undefined) {
        errorCollection('镜像管理', '新增批次', { status: 200, data: { state: -1, msg: '请选择升级方式' } })
        errorMessage(this.$t('peaseSelect') + this.$t('upgradeMethod'))
        return
      } else if (this.fromData.openTime === '') {
        errorCollection('镜像管理', '新增批次', { status: 200, data: { state: -1, msg: '请选择生效时间' } })
        errorMessage(this.$t('selectEffectiveTime'))
        return
      } else if (ouIds.length === 0) {
        errorCollection('镜像管理', '新增批次', { status: 200, data: { state: -1, msg: '请选择升级范围' } })
        errorMessage(this.$t('peaseSelect') + this.$t('upgradeScope'))
        return
      } else {
        if (this.addOrEditChild) {
          // 当是新增时 执行新增的接口
          this.subAddUpgrad(param)
        } else {
          // 当是编辑时 执行编辑的接口
          param.batchId = this.currentItem.batchId
          this.subEditUpgrad(param)
        }
      }
    },
    subAddUpgrad(param) {
      addUpgradebatch(param).then(res => {
        if (res.state === 0) {
          this.dialogChildApp = false
          this._getUpgradebatch()
        }
      })
    },
    subEditUpgrad(param) {
      editUpgradebatch(param).then(res => {
        if (res.state === 0) {
          this.dialogChildApp = false
          this._getUpgradebatch()
        }
      })
    },
    // 升级批次新增
    UpAppLever() {
      this.fromData = {
        imgName: this.childValue.imgName,
        seriesId: this.childValue.seriesId,
        versionName: this.childValue.versionName,
        upgradeMode: 1,
        description: this.childValue.description,
        openTime: '',
        ous: [],
      }
      this.isCheck = false
      this.checkList = []
      this._queryOuByCheck(null, true, true, this.checkList)
    },
    // 点击关闭、
    handleClose() {
      // 触发父组件事件
      this.$emit('closeChild')
    },
    // 子table 操作事件
    childOperationEvent(row, value, index) {
      // 根据操作类型去进行下一步
      if (row.type === 'upEdit') {
        this.isCheck = true
        this.editChildInfo(row.value)
      } else if (row.type === 'uoDelect') {
        this.delectInfo(row.value)
      }
    },
    // 子table编辑事件
    editChildInfo(row) {
      this.currentItem = row
      this.rootTree = []
      this._orgunitRootTree()
      this.fromData = Object.assign({}, row)

      this.checkList = []
      this.checkList = row.ouIds ? row.ouIds : []

      this._queryOuByCheck(row, true, false, this.checkList)
      setTimeout(() => {
        this.isCheck = false
      }, 1000)
    },
    // 删除批次信息
    delectInfo(row) {
      this.$confirm(this.$t('deleteThisInformation'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = { batchId: row.batchId }
        deleteUpgradebatch(param).then(res => {
          if (res.state === 0) {
            // 删除成功刷新table数据
            this._getUpgradebatch()
          }
        })
      })
    },
    // 所有租户根组织架构数据
    _queryOuByCheck(row, dialogChildApp, addOrEditChild, checkedKeys) {
      let id = row ? row.batchId : ''
      let param = { pgkId: this.childValue.imgId, batchId: id, dataType: 0 }
      this.ouByCheck = []
      queryOuByCheck(param).then(res => {
        if (res.state === 0) {
          // console.log(row, res, res.value.length, ' 所有租户根组织架构数据')
          // 去除当前行选中的数据
          if (res.value) {
            this.ouByCheck = res.value
            this.dialogChildApp = dialogChildApp
            this.addOrEditChild = addOrEditChild
          }
        }
        if (this.$refs.childCheckTree) {
          this.$refs.childCheckTree.setCheckedKeys(checkedKeys)
        }
      })
    },
    // 升级批次配置
    upgradeLever(value) {
      this.columns = [
        {
          attrName: 'imgName',
          label: this.$t('imageName'),
        },
        {
          attrName: 'seriesId',
          label: this.$t('ImageID'),
          align: 'right',
          width: 120,
        },
        {
          attrName: 'versionName',
          label: this.$t('versionNo'),
          align: 'right',
          width: 160,
        },

        {
          attrName: 'ouNames',
          label: this.$t('upgradeScope'),
        },
        {
          attrName: 'openTime',
          align: 'center',
          width: 180,
          label: this.$t('effectiveStartTime'),
          sort: 'openTime',
        },
      ]
      this.dateOperation = [
        {
          operateName: this.$t('edit'),
          type: 'upEdit',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'uoDelect',
          IsHad: '',
          class: 'editClick',
        },
      ]
    },
    // 所有租户根组织架构数据
    _orgunitRootTree() {
      let deviceType = [1,2,3]
      if (this.appActiveName === 'ih5') {
        deviceType = [0]
      }
      orgunitRootTree({rootOuIds:this.childValue.ouIds,deviceType:deviceType}).then(res => {
        if (res.state === 0) {
          this.rootTree = res.data
          this.$nextTick(() => {
            if (this.$refs.childCheckTree) {
              this.$refs.childCheckTree.filter(this.searchOu)
            }
          })
        }
      })
    },
    // 请求table数据
    _getUpgradebatch() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        imgId: this.childValue.imgId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getUpgradebatch(param).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
    },
    // 切换、页数据
    handleSizeChange(val) {
      this.pageSize = val
      this._getUpgradebatch()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._getUpgradebatch()
    },
  },
  mounted() {
    this.upgradeLever()
    this._orgunitRootTree()
    this._getUpgradebatch()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
>>>.el-table
  height 640px!important
  min-height 480px!important;/* no */
  overflow: auto
.lever-main
  width 100%
// 全局弹窗
.mask
  position fixed
  top 78px
  left: 0;
  z-index 10
  width 100%
  height 100%
.child-content
  width 100%
  height: 100%;
  border-radius 8px
  position fixed
  top 78px
  left 0
  z-index 2008
  background: #fff
  color #333
  .child-main
    padding 15px /* no */
    .modal-header
      padding 15px
      border-bottom 1px solid #0057A8
      font-weight 700
      span
        font-size 18px
      .close
        float right
        font-weight 700
    .table-container
      margin 15px
.add-btn
  margin-top 10px
  margin-bottom 10px
  padding 12px 20px!important
  float: right
.check-box
  height 83%
  >>>.el-form-item__content
    height 100%
  .check-tree
    height 93%
    overflow auto
.el-tree
  height 100%
  overflow auto
  padding 10px 20px
  border var(--search-input-border)
.el-input
  width 100%!important
.settingDialog
  display flex
  overflow hidden
  flex-direction row
  color var(--search-label-color)
  height 370px
  .left-content
    width 46%
  .right-content
    width 54%
    height 100%
// 深色样式
.theme-dark
  .child-content
    background: #001143
    color #fff
>>> .el-tree{
  color var(--new-color-white)!important
}
</style>
